export default __webpack_public_path__ + "static/media/48.506bb829.jpg";